var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{staticClass:"cursor-pointer",class:['bf-icon', `icon-${_vm.size}`, `icon-distro-${_vm.name}`]})
}
var staticRenderFns = []

export { render, staticRenderFns }